;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    type: {
      default: "button",
      type: String
    },
    styles: Array,
    caption: String,
    label: String,
    action: Function,
    href: String
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === "button")?_c('button',{staticClass:"ss-button",class:_vm.styles ? _vm.styles.join(" ") : null,attrs:{"area-label":_vm.label,"type":"button"},on:{"click":_vm.action}},[(_vm.caption)?_c('p',{staticClass:"ss-button__caption"},[_vm._v(_vm._s(_vm.caption))]):_vm._e(),(_vm.label)?_c('p',{staticClass:"ss-button__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()]):(_vm.type === "a")?_c('a',{staticClass:"ss-button",class:_vm.styles ? _vm.styles.join(" ") : null,attrs:{"href":_vm.href}},[(_vm.caption)?_c('p',{staticClass:"ss-button__caption"},[_vm._v(_vm._s(_vm.caption))]):_vm._e(),(_vm.label)?_c('p',{staticClass:"ss-button__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()]):_vm._e()}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5ec1231e", __vue__options__)
  } else {
    hotAPI.reload("data-v-5ec1231e", __vue__options__)
  }
})()}